import { FormikContextType } from 'formik'
import { Contact, ContactOrganization } from '../../../model/Contact'
import { Profession, Speciality } from '../../../model/Professions'

export interface ContactFormFields {
  title: string
  firstName: string
  familyName: string
  profession: Profession | null
  speciality: Speciality | null
  organizations: ContactOrganization[]
  ppIdentifier: string
  notes: string
}

export interface ContactFormProps {
  disabled: boolean
  formik: FormikContextType<ContactFormFields>
}

export const getDefaultValues = (): ContactFormFields => ({
  title: '',
  firstName: '',
  familyName: '',
  profession: null,
  speciality: null,
  notes: '',
  organizations: [
    {
      id: '',
      technicalId: '',
      name: '',
      emailAddress: '',
      phoneNumber: '',
      private: true,
      address: {
        street2: null,
        street: '',
        zipCode: '',
        city: '',
        country: 'France',
      },
    },
  ],
  ppIdentifier: '',
})

export function getInitialValues(contact: Contact): ContactFormFields {
  return {
    title: contact.title || '',
    firstName: contact.firstName || '',
    familyName: contact.familyName || '',
    profession: contact.profession || null,
    speciality: contact.speciality || null,
    ppIdentifier: contact.ppIdentifier || '',
    notes: contact.notes || '',
    organizations: contact.organizations.length
      ? contact.organizations.map(sanitizeOrganizations)
      : [
          {
            id: '',
            technicalId: '',
            name: '',
            private: true,
            emailAddress: '',
            phoneNumber: '',
            address: {
              street2: null,
              street: '',
              zipCode: '',
              city: '',
              country: '',
            },
          },
        ],
  }
}

const sanitizeOrganizations = ({
  name,
  emailAddress,
  phoneNumber,
  ...organization
}: ContactOrganization) => ({
  ...organization,
  name: name ?? '',
  emailAddress: emailAddress ?? '',
  phoneNumber: phoneNumber ?? '',
})
